import React, { createContext, useContext } from "react";
import { useParams } from "react-router-dom";

import { getProject } from "./api";
import { useFormContext } from "react-hook-form";

const MCSContext = createContext();

export const useMcsContext = () => useContext(MCSContext);

function MCSContextProvider({ children }) {
  const projectId = useParams();
  const [project, setProject] = React.useState({
    id: projectId.id,
    drawings: [],
    mrqs: [],
    pos: [],
    mrvs: [],
    srvs: [],

    selectedDrawings: [],
    selectedMrq: {},
    selectedBidMrq: {},
    selectedPo: {},
  });
  const [currentTab, setCurrentTab] = React.useState(0);

  const setSelectedDrawings = (drawings) => {
    setProject({ ...project, selectedDrawings: drawings });
  };

  if (!project.name) {
    const func = async () => {
      const res = await getProject({ projectId: project.id });
      setProject({ ...project, ...res, data: data() });
    };
    func();
  }

  console.log({ project });
  const setSelectedMrqData = (mrq) => {
    setProject({ ...project, selectedMrq: {} });
    setProject({ ...project, selectedMrq: mrq });
  };

  const setSelectedBidMrqData = (mrq) => {
    setProject({ ...project, selectedBidMrq: {} });
    setProject({ ...project, selectedBidMrq: mrq });
  };

  const setSelectedPoManager = (po) => {
    setProject({ ...project, selectedPo: po });
  };

  const updateProjectAfterCreateMrq = (res) => {
    console.log({ res });
    setProject({
      ...project,
      selectedDrawings: res.drawings,
      // selectedMrq: res.mrq,
    });
  };
  const { getValues } = useFormContext();
  const data = () => {
    if (getValues()?.revisions?.[0]) {
      const projData = getValues().revisions[0].data;
      return typeof projData === "string" ? JSON.parse(projData) : projData;
    }
  };

  React.useEffect(() => {
    const func = async () => {
      const res = await getProject({ projectId: project.id });
      setProject({ ...project, ...res, data: data() });
    };
    func();
  }, []);

  console.log({ project });

  const [bidData, setBidData] = React.useState([]);
  const [BidTableRows, setBidTableRows] = React.useState([]);

  const [selectedMrqMaterials, setSelectedMrqMaterials] = React.useState([]);

  return (
    <MCSContext.Provider
      value={{
        currentTab,
        setCurrentTab,
        project,
        setProject,
        setSelectedDrawings,
        setSelectedMrqData,
        setSelectedPoManager,

        selectedMrqMaterials,
        setSelectedMrqMaterials,
        updateProjectAfterCreateMrq,

        setSelectedBidMrqData,

        bidData: bidData ? bidData : [],
        setBidData,
        BidTableRows,
        setBidTableRows,
      }}
    >
      {children}
    </MCSContext.Provider>
  );
}

export { MCSContextProvider, MCSContext };
